import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  formatCurrency,
  formatInteger,
  formatPercent,
} from './fnbEodReportUtils'

function MetricItem({ label, value }) {
  return (
    <Col sm={6} lg={4}>
      <div className="fnb-eod-summary-item">
        <p className="fnb-eod-summary-item__label mb-1">{label}</p>
        <p className="fnb-eod-summary-item__value mb-0">{value}</p>
      </div>
    </Col>
  )
}

export default function FnbEodReportStandMetrics({ standMetrics }) {
  if (!standMetrics) return null

  const topSellingLabel = standMetrics.topSellingItem
    ? `${standMetrics.topSellingItem.name} (${formatInteger(
        standMetrics.topSellingItem.quantitySold
      )} sold)`
    : '—'

  const highestRevenueLabel = standMetrics.highestRevenueItem
    ? `${standMetrics.highestRevenueItem.name} (${formatCurrency(
        standMetrics.highestRevenueItem.grossSales
      )})`
    : '—'

  return (
    <Card body className="card--md">
      <h2 className="h5 mb-3">Stand Performance Metrics</h2>
      <Row className="g-3">
        <MetricItem
          label="Revenue Per Attendee"
          value={
            standMetrics.revenuePerAttendee == null
              ? '—'
              : formatCurrency(standMetrics.revenuePerAttendee)
          }
        />
        <MetricItem
          label="Average Items Per Order"
          value={
            standMetrics.averageItemsPerOrder == null
              ? '—'
              : standMetrics.averageItemsPerOrder.toFixed(1)
          }
        />
        <MetricItem label="Top Selling Item" value={topSellingLabel} />
        <MetricItem label="Highest Revenue Item" value={highestRevenueLabel} />
        <MetricItem
          label="Sell Through Rate"
          value={
            standMetrics.sellThroughRate == null
              ? '—'
              : formatPercent(standMetrics.sellThroughRate)
          }
        />
        <MetricItem
          label="Waste Percentage"
          value={
            standMetrics.wastePercentage == null
              ? '—'
              : formatPercent(standMetrics.wastePercentage)
          }
        />
      </Row>
    </Card>
  )
}
